import { Stack } from '@mui/material';

import { AccordionWithHeading, ContentLoading, type TablelikeRow } from '../../../components/general';
import { HeadingWithTag } from '../../../components/general/HeadingWithTag.tsx';
import { LabelValue } from '../../../components/general/LabelValue.tsx';
import { type TerminProps } from '../../../utils';
import { content } from './TerminZeitlicherAblaufCard.content';
import { printZusatzinfo } from './TerminZeitlicherAblaufCard.utils';

export const TerminZeitlicherAblaufCard = ({
  bordered,
  thema: { planungsinformation },
  withoutAccordion,
}: TerminProps) => {
  if (!planungsinformation) {
    return (
      <AccordionWithHeading heading={content.heading}>
        <ContentLoading />
      </AccordionWithHeading>
    );
  }

  const printTable: TablelikeRow[] =
    planungsinformation.zeitlicherAblauf?.map((ablaufTagTemplate) => [
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      content.units.tag + ' ' + ablaufTagTemplate.tagNr,
      ablaufTagTemplate.startZeit + ' - ' + ablaufTagTemplate.endZeit,
    ]) ?? [];

  if (planungsinformation.zusatzinfoAblauf !== null) {
    printTable.push([content.fields.zusatzinfo, printZusatzinfo(planungsinformation)]);
  }

  return (
    <AccordionWithHeading
      heading={<HeadingWithTag heading={content.heading} tag="cserv" />}
      bordered={bordered}
      grow={true}
      noAccordion={withoutAccordion}
    >
      <Stack gap={2}>
        {printTable.map(([label, value]) => (
          // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
          <LabelValue key={`${label}${value}`} label={label} value={value} />
        ))}
      </Stack>
    </AccordionWithHeading>
  );
};
